import { render } from "./Phonenum.vue?vue&type=template&id=3fb9fe1e&scoped=true"
import script from "./Phonenum.vue?vue&type=script&lang=js"
export * from "./Phonenum.vue?vue&type=script&lang=js"

import "./Phonenum.vue?vue&type=style&index=0&id=3fb9fe1e&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_genba/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb9fe1e"]])

export default __exports__